export default __webpack_public_path__ + "979f772663b66bf414d403e533410d48.jpg";